import { createContext as t, use as n } from "react";
import { jsx as o } from "react/jsx-runtime";
var i = t(null);
i.displayName = "ApiContext";
var s = ({ children: r, ...e }) => /* @__PURE__ */ o(i, {
  value: { ...e },
  children: r
});
function u(r) {
  const e = n(i);
  if (!e) {
    if (r?.optional) return null;
    throw new Error("useWebappApi Hook must be used within an ApiProvider");
  }
  return {
    api: e.client,
    server: e.server,
    analytics: e.analytics
  };
}
export {
  s as ApiProvider,
  u as useWebappApi
};

//# sourceMappingURL=ApiProvider.js.map